package com.karyadina.di


import com.karyadina.cloudsync.di.webCloudSyncModule
import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration

/**
 * Web-specific Koin initialization
 * Loads common modules plus web-specific CloudSync services
 */
fun initKoinWeb(appDeclaration: KoinAppDeclaration = {}) = startKoin {
    appDeclaration()
    modules(appModule, webCloudSyncModule)
}
